import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';

function calculateTimeLeft(fromTimestamp, timeout) {
  var difference = fromTimestamp - new Date().getTime() + timeout * 1000;

  if (difference > 0) {
    return Math.round(difference / 1000);
  }

  return 0;
}

export function CountdownTimer(_ref) {
  var children = _ref.children,
      fromTimestamp = _ref.fromTimestamp,
      timeout = _ref.timeout,
      onTimeoutExpired = _ref.onTimeoutExpired;
  var timerRef = React.useRef();

  var _React$useState = React.useState(function () {
    return calculateTimeLeft(fromTimestamp, timeout);
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      timeLeft = _React$useState2[0],
      setTimeLeft = _React$useState2[1];

  React.useEffect(function () {
    timerRef.current = window.setTimeout(function () {
      setTimeLeft(calculateTimeLeft(fromTimestamp, timeout));
    }, 1000);
    return function () {
      window.clearTimeout(timerRef.current);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft, fromTimestamp]);
  React.useEffect(function () {
    if (timeLeft === 0 && onTimeoutExpired) {
      onTimeoutExpired();
    }
  }, [timeLeft, onTimeoutExpired]);

  if (!fromTimestamp || !timeout || !timeLeft) {
    return null;
  }

  if (children) {
    return children({
      timeLeft: timeLeft
    });
  }

  return /*#__PURE__*/React.createElement("span", null, timeLeft);
}